{
  "title": "Budget",
  "lead": "What the project may spend per month, excluding VAT. Notifications at 50, 80 and 100\u00a0%; nothing is ever powered off or deleted by itself.",
  "used": "Spent",
  "forecastUse": "Forecast for the month",
  "ofBudget": "of this month's budget of {{amount}}",
  "raisedThisMonth": "including a one-time raise of {{amount}}",
  "usedShort": "Spent {{percent}}\u00a0%",
  "forecastShort": "Forecast: {{percent}}\u00a0% of the budget",
  "summary": "{{amount}} · forecast {{percent}}\u00a0%",
  "set": "Set a budget",
  "change": "Change the budget",
  "remove": "Remove the budget",
  "requestRaise": "Request a raise",
  "decide": "Decide",
  "decided": "This request was decided already.",
  "monthly": "Per month",
  "margin": "Change margin",
  "marginShort": "margin {{margin}}\u00a0%",
  "marginValue": "{{margin}}\u00a0% — up to {{limit}}",
  "marginDefault": "The organisation's default",
  "marginOwn": "This project's own",
  "marginLabel": "Change margin, %",
  "marginHint": "How far changes to services that already run may take the forecast above the budget — for urgent small changes. Empty: the organisation's default ({{margin}}\u00a0%).",
  "marginInvalid": "A whole number from 0 to 100.",
  "ruleNew": "New paid services — servers, volumes, IP addresses, floating IPs, snapshots, load balancers — cannot be ordered once the month's forecast reaches the budget.",
  "ruleChange": "Changes to services that already run — server type, backups, volume size, IPv4 for a server — are allowed while the forecast stays within the budget plus the change margin ({{margin}}\u00a0%).",
  "ruleNothing": "Deleting, shrinking and powering off are always allowed. Administrators are not stopped by the rules, only warned.",
  "exceededBadge": "Budget reached: no new services",
  "thresholds": "Notification thresholds, %",
  "thresholdsHint": "Comma-separated, e.g. 50, 80, 100: each notifies once a month, on the actual and on the forecast.",
  "thresholdsInvalid": "One to five different numbers from 1 to 200.",
  "none": "No budget: the project's spending is not limited.",
  "noneShort": "No budget",
  "history": "Budget history",
  "historyFrom": "From {{month}}",
  "alert": {
    "actual": "{{threshold}}\u00a0% of the budget spent",
    "forecast": "The forecast reached {{threshold}}\u00a0% of the budget"
  },
  "raises": "Raise requests",
  "raiseAmount": "Raise",
  "kinds": {
    "once": "This month only",
    "permanent": "Permanent"
  },
  "reason": "Reason",
  "requestedBy": "By whom and when",
  "status": "Decision",
  "statuses": {
    "pending": "Waiting",
    "approved": "Approved",
    "rejected": "Rejected"
  },
  "saved": "Budget saved",
  "removed": "Budget removed",
  "dialogLead": "An amount per calendar month excluding VAT, in the price list's currency. It applies from this month on; past months keep their own budget. The change is confirmed with your second factor.",
  "amountLabel": "Budget per month, {{currency}}",
  "amountHint": "For example 250 or 99.90.",
  "amountInvalid": "Enter an amount above zero, for example 250 or 99.90.",
  "raiseLead": "Administrators get the request and approve or reject it.",
  "raiseBy": "Raise by, {{currency}}",
  "raiseKind": "For how long",
  "send": "Send the request",
  "requested": "Request sent to the administrators",
  "decideTitle": "Budget raise request: {{project}}",
  "decideLead": "{{name}} asks for {{amount}} ({{kind}}). The decision is confirmed with your second factor.",
  "note": "Comment (optional)",
  "approve": "Approve",
  "reject": "Reject",
  "approved": "Request approved",
  "rejected": "Request rejected",
  "pending": "Budget raise requests",
  "pendingLead": "Project owners ask for more. An approved one-time raise lasts until the month ends; a permanent one changes the budget from this month on.",
  "defaultTitle": "Default change margin",
  "defaultLead": "How far changes to services that already run may take the forecast above the budget, for projects without their own margin. The margin never opens the way to new services.",
  "defaultMargin": "Margin, %",
  "defaultSaved": "Default margin saved",
  "exceededNew": "The project's budget of {{budget}} is reached: no new paid services can be ordered (the month's forecast after the order: {{forecast}}).",
  "exceededChange": "The month's forecast after the change would be {{forecast}}, {{over}} over the budget plus its {{margin}}\u00a0% change margin ({{limit}}).",
  "changeAdds": "Adds about {{amount}} to this month ({{monthly}} for a full month), excluding VAT.",
  "willBeRefusedNew": "The project's budget of {{budget}} is or would be reached: a new service will be refused ({{over}} over).",
  "willBeRefusedChange": "This change takes the forecast {{over}} beyond the budget plus its {{margin}}\u00a0% change margin ({{limit}}) and will be refused.",
  "overAsAdminNew": "The project's budget of {{budget}} would be exceeded by {{over}}. You are an administrator: the order will not be stopped.",
  "overAsAdminChange": "This change goes {{over}} beyond the budget plus its margin ({{limit}}). You are an administrator: it will not be stopped."
}
